import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e125a8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "privilege" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "会员权益")
], -1))
const _hoisted_3 = { class: "table-wrap" }

import { defineAsyncComponent } from 'vue'

// 引入组件

export default /*#__PURE__*/_defineComponent({
  __name: 'Privilege',
  setup(__props) {

_useCssVars(_ctx => ({
  "0331092e": (titleImg1),
  "0331092c": (titleImg2)
}))

const Layout = defineAsyncComponent(() => import('@/layout/index.vue'));
const VipCompare = defineAsyncComponent(() => import("@/components/vipCompare/index.vue"));


// css所需图片
const titleImg1 = `url(${require('@/assets/member/img/member/privilege-title-icon.png')})`;
const titleImg2 = `url(${require('@/assets/member/img/member/privilege-title-icon2.png')})`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Layout), {
    footer: false,
    parent: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(VipCompare))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})